import { TCargoEOS } from '@types';

const getDimensionText = (cargo: any, field: string): string => {
	if (cargo === null || !(field in cargo)) {
		return '0cm';
	}
	return `${cargo[field] || 0}cm`;

}

/** @returns string of the "100cm x 100cm x 100cm" in the order length, width, height */
export const getDimensionsText = (cargo: TCargoEOS, dashIfEmpty?: boolean): string => {
	const string = ['length', 'width', 'height'].map((p) => getDimensionText(cargo, p)).join(' x ');
	if (string === '0cm x 0cm x 0cm' && dashIfEmpty) return '-';
	return string;
}
